import { IGroup } from "src/app/interfaces/group";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngstack/translate";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IConfirm } from "src/app/interfaces/confirm";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { GroupEntryComponent } from "../group-entry/group-entry.component";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { GroupService } from "src/app/services/http/business/group/group.service";
import { ErrorsService } from "src/app/services/common/errors.service";

@Component({
  selector: "app-group-detail",
  templateUrl: "./group-detail.component.html",
  styleUrls: ["./group-detail.component.css"]
})
export class GroupDetailComponent implements OnInit {
  @Input() groupDetail: IGroup;
  @Input() groupList: IGroup;
  @Input() actionList: IGroup;
  @Output() showDetail = new EventEmitter();
  errorMessage: string;

  constructor(
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private groupService: GroupService,
    public translate: TranslateService,
    private errorService: ErrorsService
  ) {}

  ngOnInit() {}

  editGroup() {
    this.dialog
      .open(GroupEntryComponent, {
        data: this.groupDetail
      })
      .afterClosed()
      .subscribe(
        res => {
          this.groupDetail.Title = res.Title;
          this.groupDetail.Code = res.Code;
          this.groupService.fire();
        },
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("error.transaction"),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
      );
  }

  delete(): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.group") + " " + this.groupDetail.Title
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res)
          this.groupService.delete(this.groupDetail).subscribe(
           () => {
              this.groupService.fire();
              this.groupService.hide();
            },
            err => {
              this.errorService.recordHasBennUsed(err);
            }
          );
      });
  }
}
